import * as React from "react";

interface IPoiItemAddressProps {
    addressline: string;
}

const PoiItemAddress = ({ addressline }: IPoiItemAddressProps) => {
    return <span className="result-address-line">{addressline}</span>;
}

export default PoiItemAddress;